import React from 'react';
import '../App.css';

const CSAE = () => {
  return (
    <div className="" style={{ 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center', 
      minHeight: '100vh', 
      overflow: 'auto', 
      width: '100vw', 
      background: '#a1a1a1', 
      padding: '20px', 
      boxSizing: 'border-box'
    }}>
      <div style={{ 
        width: '100%', 
        maxWidth: '800px', 
        background: '#a1a1a1', 
        padding: '20px', 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'center',
        textAlign: 'center'
      }}>
        <h1 style={{ textAlign: 'center', marginBottom: '30px' }}>Child Safety</h1>
        <p style={{ 
          textAlign: 'center',
          lineHeight: '1.6',
          fontSize: '16px',
          maxWidth: '600px'
        }}>
          ChessThread is committed to protecting children and preventing child sexual abuse and exploitation. 
          We do not permit any content, activity, or behavior that promotes or depicts CSAE in any form. 
          Reports of CSAE are reviewed immediately, and confirmed violations will result in permanent removal 
          of the content and account, and reporting to relevant authorities.
        </p>
      </div>
    </div>
  );
};

export default CSAE;